export default "__VITE_ASSET__86e63227__"